import { adminHostLink } from "@/admin/itemLinks.ts";
import { WButton } from "@/components/button/WButton.tsx";
import type { AdminHost } from "@warrenio/api-spec/spec.oats.gen";

export function HostLink({ item }: { item: Pick<AdminHost, "uuid" | "name"> }) {
    return <WButton label={item.name} variant="tableLink" action={adminHostLink(item.uuid)} />;
}
